import { useOwnedTopicsTableModel } from './owned-topics-table.model'
import type { IOwnedTopicsTableProps } from './owned-topics-table.types'
import { OwnedTopicsTableView } from './owned-topics-table.view'

export const OwnedTopicsTable = ({ tableData }: IOwnedTopicsTableProps) => {
  const ownedTopicsTableModel = useOwnedTopicsTableModel()
  return <OwnedTopicsTableView {...ownedTopicsTableModel} tableData={tableData} />
}
